<button mat-stroked-button class="hidden xl:inline-flex" (click)="goBack()" matTooltip="Back">
  <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
</button>

<button mat-icon-button class="inline-flex xl:hidden" (click)="goBack()" matTooltip="Back">
  <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
</button>
